// Capacitor-aware helpers. We avoid a hard dependency on @capacitor/core so the
// web build works before Capacitor is installed; we feature-detect at runtime.
export function isNativePlatform(): boolean {
  const cap = (globalThis as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
  return Boolean(cap?.isNativePlatform?.())
}

// Absolute origin of the booking API. In dev this is empty → relative "/api/..."
// which Vite proxies to the Symfony backend (no CORS). For Capacitor/native and
// production builds, VITE_API_BASE points at the live origin.
export const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '')
